import type { StaticImageData } from "@/components/Image";

import CoinbasePreview from "@/assets/images/acceptUSDCPreview.png";
import CoinbaseLogoBlue from "@/assets/images/CoinbaseLogoBlue.svg";
import CoinbaseMiniLogo from "@/assets/images/coinbaseMiniLogo.png";

import ZentryPreview from "@/assets/images/ZentryPreview.png";
import ZentryBlueLogo from "@/assets/images/ZentryBlueIcon.svg";
import ZentryMini from "@/assets/images/zentryMiniLogo.png";

import SpiritDAOPreview from "@/assets/images/spiritdaoPreview.png";
import SpiritDAOBlue from "@/assets/images/spiritdaoBlue.svg";
import SpiritDAOMini from "@/assets/images/spiritdaoMiniLogo.png";

import CoffeeDaysPreview from "@/assets/images/coffeedaysPreview.png";

import OCSPreview from "@/assets/images/ocsshopPreview.png";

import DegenTaxPreview from "@/assets/images/degentaxPreview.png";
import DegenTaxBlue from "@/assets/images/degentaxBlue.png";
import DegenTaxMini from "@/assets/images/degentaxMiniLogo.png";

export type PortfolioProject = {
  descrip: string;
  link: string;
  preview: StaticImageData | string;
  blueLogo: StaticImageData | string;
  miniLogo: StaticImageData | string;
  logoText: string;
};

// Order matters: the home page features the first HOME_FEATURED_COUNT entries,
// and /portfolio shows them all.
export const PORTFOLIO: PortfolioProject[] = [
  {
    descrip: "Fewer fees. Save more. Do more with USDC",
    link: "https://acceptusdc.com/",
    preview: CoinbasePreview,
    blueLogo: CoinbaseLogoBlue,
    miniLogo: CoinbaseMiniLogo,
    logoText: "Coinbase - Accept USDC",
  },
  {
    descrip: "Enter the Metagame Layer Unleash the Play Economy",
    link: "https://zentry.com/",
    preview: ZentryPreview,
    blueLogo: ZentryBlueLogo,
    miniLogo: ZentryMini,
    logoText: "Zentry",
  },
  {
    descrip: "Redeem your Spirit DAO Comic Mint",
    link: "https://spiritdao.soleye.com/",
    preview: SpiritDAOPreview,
    blueLogo: SpiritDAOBlue,
    miniLogo: SpiritDAOMini,
    logoText: "Spirit DAO",
  },
  {
    descrip: "Buy sweet On Chain Summer merch from Coinbase",
    link: "https://wallet.coinbase.com/ocs/shop",
    preview: OCSPreview,
    blueLogo: CoinbaseLogoBlue,
    miniLogo: CoinbaseMiniLogo,
    logoText: "Coinbase - On Chain Summer Shop",
  },
  {
    descrip: "$1 coffee ☕ all summer long",
    link: "https://wallet.coinbase.com/ocs/coffeedays",
    preview: CoffeeDaysPreview,
    blueLogo: CoinbaseLogoBlue,
    miniLogo: CoinbaseMiniLogo,
    logoText: "Coinbase - Coffee Days",
  },
  {
    descrip: "Spend what you have, not what you owe",
    link: "https://degentax.io/",
    preview: DegenTaxPreview,
    blueLogo: DegenTaxBlue,
    miniLogo: DegenTaxMini,
    logoText: "Degen Tax",
  },
];

export const HOME_FEATURED_COUNT = 4;
